import type { FaireProductEntity } from "../../entity_types/product";

export const p_vnf3c53k58: FaireProductEntity = {
  token: "p_vnf3c53k58",
  type: "product",
  name: "Coquette Football Patch Sweatshirt - Childrens Clothing",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/34a2322e7e2d51636ee7b829df9e53becd53e245dda767e6cf34474cf07481f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15e5bd192d73179f0a8defdfbf3dae55426ea39c15bc76eac01648e05eab4d56.jpeg",
    "https://cdn.faire.com/fastly/8e03ce7374423d13c064bf68d5bccf69495a19e9057568438585c9bc889fea44.jpeg",
    "https://cdn.faire.com/fastly/b16c7e51ceeee61b263f0bee60e50f45161847cb3bffd1690d7a8848ca3c9a81.jpeg",
    "https://cdn.faire.com/fastly/9c92e2c79eb0878afae2efffb6c3af6628e1726a0f950d0b49c4dc482963415d.jpeg",
  ],
  priceDollars: 24,
  description:
    "The Coquette Football Patch Sweatshirt is a fun and cute sweatshirt for celebrating Game Day!\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n•Crewneck Color: Natural\n•Patch Color: Soft pink and brown chenille with an embroidered outline\n•Material: 60% Cotton/40% Polyester Fleece\n•Features: Tagless inside neck label for an itch-free wear; cozy fleece lining\n•Fit: Toddler Unisex; True to Size\n•Care: Machine washable, wash inside out, lay flat to dry, wash with like colors\n\nEach sweatshirt is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 48,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-12T07:12:33.670Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
